export const FETCH_HISTORY_REQUEST_FIRSTPACK = 'FETCH_HISTORY_REQUEST_FIRSTPACK'
export const FETCH_HISTORY_REQUEST_ALTPACK = 'FETCH_HISTORY_REQUEST_ALTPACK'
export const FETCH_HISTORY_SUCCESS = 'FETCH_HISTORY_SUCCESS'
export const FETCH_HISTORY_FAILURE = 'FETCH_HISTORY_FAILURE'
